import type { IncidentListRow } from '@/features/shared/incidentListRow';
import type { CallNotificationItem } from '@/signalr/contracts';
import type { IncidentListContext } from './incidentListContext';
import { IncidentListMap } from '@/features/shared/map/IncidentListMap';
import { CallNotificationsMap } from './map/CallNotificationsMap';

export type IncidentListMapContentProps = {
  context: IncidentListContext;
  incidents?: readonly IncidentListRow[];
  callNotifications?: readonly CallNotificationItem[];
};

export function IncidentListMapContent({ context, incidents, callNotifications }: IncidentListMapContentProps) {
  if (context === 'incidents') {
    return <IncidentListMap incidents={incidents} disableControls />;
  }

  if (context === 'callNotifications') {
    return <CallNotificationsMap callNotifications={callNotifications} disableControls />;
  }

  return null;
}
